import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { GeneralResMock } from '../types/general.type'
import { RoomArgOptions, RoomIncluded, RoomResMock } from '../types/room.type'

export const useRoom = (arg: RoomArgOptions) => {
  const roomId = arg?.id
  const page = arg?.page
  const pageSize = arg?.limit
  const query = arg?.query
  const sortDir = arg?.sortDir || 'asc'
  const status = arg?.status
  const room_type = arg?.room_type

  const { data: rooms, isLoading: roomsIsLoading } = useQuery({
    enabled: !!roomId,
    queryFn: async () => {
      const endpoint = `units/${roomId}/rooms`

      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<RoomResMock[], RoomIncluded[]>>(endpoint, {
        params: {
          ...(page && { 'page[number]': page }),
          ...(pageSize && { 'page[size]': pageSize }),
          ...(query && { query }),
          ...(sortDir && { sort_dir: sortDir }),
          ...(status && { status }),
          ...(room_type && { room_type })
        }
      })
      return data
    },
    queryKey: ['room', roomId, page, pageSize, query, sortDir, status, room_type]
  })

  const { mutateAsync: addRoom } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post(`units/${roomId}/rooms`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['room'] })
  })

  const { mutateAsync: updateRoom } = useMutation({
    mutationFn: async ({ data, id }: { data: any; id: string }) => {
      await AXIOS_INSTANCE.patch(`rooms/${id}`, data, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['room'] })
  })

  const { mutateAsync: deleteRoom } = useMutation({
    mutationFn: async (id: string) => {
      await AXIOS_INSTANCE.delete(`rooms/${id}`)
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['room'] })
  })

  return {
    addRoom,
    deleteRoom,
    roomsIsLoading,
    roomCount: rooms?.meta.pagination,
    rooms: rooms?.data,
    updateRoom
  }
}
